"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRawClasses = exports.getNormalizedProps = exports.normalizeKey = void 0;
var normalizeKey = function (name) {
    return name
        .trim()
        .replace(/( |-)/g, "_")
        .split("_")
        .map(function (str) { return str.charAt(0).toUpperCase() + str.slice(1); })
        .join("");
};
exports.normalizeKey = normalizeKey;
var getNormalizedProps = function (props) { return function (name) {
    return props[(0, exports.normalizeKey)(name)];
}; };
exports.getNormalizedProps = getNormalizedProps;
var formatRawClasses = function (rawClasses) {
    return (rawClasses &&
        rawClasses
            .replaceAll(" ", "")
            .replace("[", "")
            .replace("]", "")
            .replaceAll(",", " ")) ||
        "";
};
exports.formatRawClasses = formatRawClasses;
